<template>
  <form @submit.prevent="save">
    <v-card>
      <v-toolbar flat color="primary">
        <v-toolbar-title>Mitglied hinzufügen</v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-card-text>
        Eine E-Mail Adresse eines Nutzers angeben, um ihm eine Einladung für das Team zu schicken.
      </v-card-text>
      <v-card-text>
        <v-text-field
          v-model="form.email"
          label="Email"
          required
          class="form-control"
          type="email"
          name="email"
          :class="{ 'is-invalid': form.errors.email }"
          :error="form.errors.email"
          :error-messages="form.errors.email"
        />
      </v-card-text>
      <v-card-text v-if="availableRoles.length > 0">
        <v-list>
          <v-list-item-group v-model="form.role" mandatory>
            <v-list-item
              v-for="role in availableRoles"
              :key="role.key"
              :value="role.key"
              two-line
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ role.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ role.description }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-avatar v-if="form.role == role.key">
                <svg
                  class="ml-2 h-5 w-5 text-green-400"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </v-list-item-avatar>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" type="submit">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>
export default {
   props: {
      team: {
         type: Object,
         required: true,
      },
      availableRoles: {
         type: Array,
         required: true,
      },
   },
   data () {
      return {
         form: this.$inertia.form(
            {
               email: '',
               role: null,
            }
         ),
      }
   },
   created () {},
   methods: {
      save () {
         this.form.post(this.route('team-members.store', this.team), {
            preserveScroll: true
         })
      },
   },
}
</script>

<style>
</style>
